<div class="container-fluid fixed-header py-2">
  <div class="row align-items-center">

      <div class="col-12 col-md-8 d-flex justify-content-between align-items-center mb-2 mb-md-0">

          <app-pagetitle title="{{ deviceName }} : {{ deviceType }}" [breadcrumbItems]="breadCrumbItems"
              [deviceInfo]="true">
          </app-pagetitle>
      </div>

      <div class="col-12 col-md-4 d-flex justify-content-between justify-content-md-end align-items-center gap-2 mb-2 mb-md-0">
            <button (click)="refreshData()" type="button" class="btn btn-success small"
                  title="Click to Get Live Data">
                  <i class="ri-refresh-line text-dark align-middle mt-5 display-6"></i>
                  Refresh
            </button>
            <button (click)="backbtn('backToDashboard')" type="button" class="btn btn-primary ms-2 ml-1 small">
              <Strong>&lt;&lt;</Strong> Back To Dashboard
          </button>
      </div>
  </div>
</div>

<div class="container-fluid">
  <div class="row mb-0 header">
      <div class="col-md-12">
          <div class="row mb-0">
              <div class="col-md-12 d-flex">
                  <div class="col-md-12">

                      <div class="row d-flex flex-wrap gap-3 justify-content-between">
                          <!-- First Card -->
                          <div class="card col-md-6 shadow rounded mb-0">
                              <div class="card-body p-2">
                                  <div class="row g-2 justify-content-between">
                                      <!-- Current Box -->
                                      <div class="col ml-1 text-center parameter-box current-box"
                                          (click)="openModal(currenttemplate, 'current')"
                                          title="Click to Open Today's History Chart" style="cursor: pointer">
                                          <!-- <i class="ri-flashlight-line text-dark mb-2 display-6"></i> -->
                                          <span>
                                              <span class="mb-0 digit" style="font-size: 22px;color: #007d79; ">
                                                  {{ current || 0 }}
                                              </span>
                                          </span><small>amps</small>
                                          <p class="text fw-bold mb-1">CURRENT</p>

                                      </div>

                                      <!-- R-Power Box -->
                                      <div class="col ml-1 text-center parameter-box rpower-box"
                                          (click)="openModal(currenttemplate, 'real_power')"
                                          title="Click to Open Today's History Chart" style="cursor: pointer">
                                          <!-- <i class="ri-flashlight-line text-dark mb-2 display-6"></i> -->
                                          <span>
                                              <span class="mb-0 digit" style="font-size: 22px; color: #007d79;">{{
                                                  r_power || 0 }}
                                              </span> <small>W</small>
                                          </span>
                                          <p class="text fw-bold mb-1">R-POWER</p>

                                      </div>

                                      <!-- A-Power Box -->
                                      <div class="col ml-1 text-center parameter-box apower-box"
                                          (click)="openModal(currenttemplate, 'apparent_power')"
                                          title="Click to Open Today's History Chart" style="cursor: pointer">
                                          <!-- <i class="ri-battery-2-charge-line text-dark mb-2 display-6"></i> -->
                                          <span>
                                              <span class="mb-0 digit" style="font-size: 22px; color: #007d79;">{{
                                                  a_power || 0 }} </span><small>VA</small>

                                          </span>
                                          <p class="text fw-bold mb-1">A-POWER</p>
                                      </div>


                                      <!-- Reactive Power Box -->
                                      <div class="col ml-1 text-center parameter-box rapower-box"
                                          *ngIf="isReactivePower"
                                          (click)="openModal(currenttemplate, 'reactive_power')"
                                          title="Click to Open Today's History Chart" style="cursor: pointer">
                                          <!-- <i class="ri-flashlight-line text-dark mb-2 display-6"></i> -->
                                          <span>
                                              <span class="mb-0 digit" style="font-size: 22px; color: #007d79;">
                                                  {{ reactive_power || 0 }}
                                              </span><small>VAR</small>
                                          </span>

                                          <p class="text fw-bold mb-1" style="white-space: nowrap;">RE-ACTIVE POWER</p>

                                      </div>
                                  </div>
                              </div>
                          </div>

                          <!-- Second Card -->
                          <div class="card col-md-6 shadow rounded mb-0 ">
                              <div class="card-body p-2">
                                  <div class="row g-2 justify-content-between mt-2">
                                      <!-- Shift Box -->
                                      <div class="col-lg-4 col-12 text-center parameter-box mb-2"
                                          [ngClass]="{ 'current-shift': currentShift && true }">
                                          <h5 class="mb-1 text-uppercase" style="color: #fff;">
                                              <b>{{ currentShift.shiftName }}</b>
                                          </h5>
                                          <h6 class="mb-0" style="color: #fff;">
                                              [ {{ currentShift.startTime }} - {{ currentShift.endTime }} ]
                                          </h6>
                                      </div>

                                      <!-- Last Update and Machine Status -->
                                      <div
                                          class="col-lg-8 col-12 d-flex flex-lg-row flex-column align-items-center justify-content-between">
                                          <div
                                              class="media d-flex flex-lg-row flex-column align-items-center justify-content-between w-100">
                                              <!-- Last Update -->
                                              <div class="media-body text-center mb-2 mb-lg-0">
                                                  <h5 class="fw-bold text-muted small mb-1" style="color: #000;">
                                                      Last Update
                                                  </h5>
                                                  <h6 class="mb-0 text-dark">{{ epochToHHMMSS(LUT) }}</h6>
                                              </div>

                                              <!-- Machine Status -->
                                              <div class="media-body text-center">
                                                  <h5 class="fw-bold text-muted small mb-1" style="color: #000;">
                                                      Machine Status
                                                  </h5>
                                                  <div class="spinner-grow m-1" role="status"
                                                      [style.color]="statusColor(status)"
                                                      style="width: 1rem; height: 1rem"></div>
                                                  <h6 class="mb-0 ml-3" [style.color]="statusColor(status)">
                                                      {{ currentStatus }}
                                                  </h6>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>

                      </div>

                      <!-- Third Card -->
                      <div class="row  d-flex flex-wrap gap-3 justify-content-between">
                          <!-- <div class="row justify-content-evenly"> -->
                              <!-- Production Cost -->
                              <div class="card col-md-3 text-center parameter-box energy-box  p-2">
                                <span>
                                    <span class="mb-0 digit" style="font-size: 22px; color: #007d79;">
                                        {{ powerUnitCost || 0 }}
                                    </span>
                                </span>
                                <h5 class="text fw-bold mb-1"><b> Production Cost </b></h5>
                              </div>
                              <!-- T-Energy Box -->
                              <div class="card col-md-2 text-center parameter-box energy-box  p-2">
                                  <!-- <i class="ri-battery-line text mb-2 display-6"></i> -->
                                  <span>
                                      <span class="mb-0 digit" style="font-size: 22px; color: #007d79;">
                                          {{ t_energy || 0 }}
                                      </span><small>KwH</small>
                                  </span>
                                  <h5 class="text fw-bold mb-1"><b> Total-Energy </b></h5>
                                  <!-- <h6 class="mb-0">{{ t_energy || 0 }} <small>KwH</small></h6> -->
                              </div>
                              <!-- Total Part Count Box -->
                              <div class="card col-md-2 text-center parameter-box totalPartCount-box flex-grow-1 p-2"
                                  (click)="openModal(currenttemplate, 'partData')"
                                  title="Click to Open Today's History Chart" style="cursor: pointer">
                                  <!-- <i class="ri-numbers-line text mb-2 display-6"></i> -->
                                  <span>
                                      <span class="mb-0 digit" style="font-size: 22px; color: #007d79;">
                                          <!-- {{ parts || 0 }} -->
                                          {{ totalHourlyPartCount || 0 }}
                                      </span>
                                      <!-- <small>VAR</small> -->
                                  </span>
                                  <h5 class="text fw-bold mb-1"><b>Total Part Count [{{ typeData || "AI" }}]</b></h5>
                                  <!-- <h6 class="mb-0">{{ parts || 0 }}</h6> -->
                              </div>

                              <!-- M-Efficiency Box -->
                              <div class="card col-md-2 text-center parameter-box efficiency-box  p-2">
                                  <!-- <i class="ri-bar-chart-line text mb-2 display-6"></i> -->
                                  <span>
                                      <span class="mb-0 digit" style="font-size: 22px;color: #007d79; ">
                                          {{ m_effic || 0 }}
                                      </span><small>%</small>
                                  </span>
                                  <h5 class="text fw-bold mb-1"><b> M-Efficiency </b></h5>
                                  <!-- <h6 class="mb-0">{{ m_effic || 0 }} <small>%</small></h6> -->
                              </div>

                              <!-- M-Utilisation Box -->
                              <div class="card col-md-3 text-center parameter-box utilisation-box  p-2">
                                  <!-- <i class="ri-pie-chart-2-line text mb-2 display-6"></i> -->
                                  <span>
                                      <span class="mb-0 digit" style="font-size: 22px;color: #007d79; ">
                                          {{ perf || 0 }}
                                      </span><small>%</small>
                                  </span>
                                  <h5 class="text fw-bold mb-1"><b>M-Utilisation</b></h5>
                                  <!-- <h6 class="mb-0">{{ perf || 0 }} <small>%</small></h6> -->
                              </div>
                          <!-- </div> -->
                      </div>


                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
<div class="container-fluid">
  <div class="row">
      <div class="col-md-12 ">
          <div class="carder card">

              <div class="card-body">
                  <!-- <button *ngIf="intervalFlag" class="btn btn-success btn-sm position-absolute"
                      style="right: 10px; top: 10px; z-index: 999" (click)="LiveChart(params)">
                      <i class="ri-refresh-line align-middle"></i>
                  </button> -->
                  <div class="row align-items-center">
                    <div class="col-12 col-md-4">
                      <div class="info-box">
                        <div class="info-text">Operator Name: <span class="highlight-primary">{{ operatorName ? operatorName: "Not Mapped"}}</span></div>
                        <div class="info-text">Part Name: <span class="highlight-success"> {{ partName ? partName: "Not Planned"}} </span></div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8 d-flex flex-wrap justify-content-center justify-content-md-between mt-1">
                        <div class="col-6 col-sm-4 col-md-2 status-box running-box text-center"
                            (click)="openModal(piechart, 'pieChart')">
                            <span class="text d-block d-lg-none" style="font-size: 10px;">Running</span>
                            <span class="text d-none d-lg-block">Running</span>
                            <h4 class="mb-0">
                                <span class="d-block d-lg-none" style="font-size: 12px;">{{ houers("running") }}</span>
                                <span class="d-none d-lg-block">{{ houers("running") }}</span>
                            </h4>
                        </div>

                        <div class="col-6 col-sm-4 col-md-2 status-box idle-box text-center"
                            (click)="openModal(piechart, 'pieChart')">
                            <span class="text d-block d-lg-none" style="font-size: 10px;">Idle</span>
                            <span class="text d-none d-lg-block">Idle</span>
                            <h4 class="mb-0">
                                <span class="d-block d-lg-none" style="font-size: 12px;">{{ houers("idle") }}</span>
                                <span class="d-none d-lg-block">{{ houers("idle") }}</span>
                            </h4>
                        </div>

                        <div class="col-6 col-sm-4 col-md-2 status-box standby-box text-center"
                            (click)="openModal(piechart, 'pieChart')">
                            <span class="text d-block d-lg-none" style="font-size: 10px;">StandBy</span>
                            <span class="text d-none d-lg-block">StandBy</span>
                            <h4 class="mb-0">
                                <span class="d-block d-lg-none" style="font-size: 12px;">{{ houers("standby") }}</span>
                                <span class="d-none d-lg-block">{{ houers("standby") }}</span>
                            </h4>
                        </div>

                        <div class="col-6 col-sm-4 col-md-2 status-box disconnect-box text-center"
                            (click)="openModal(piechart, 'pieChart')">
                            <span class="text d-block d-lg-none" style="font-size: 10px;">Off</span>
                            <span class="text d-none d-lg-block">Off</span>
                            <h4 class="mb-0">
                                <span class="d-block d-lg-none" style="font-size: 12px;">{{ houers("off") }}</span>
                                <span class="d-none d-lg-block">{{ houers("off") }}</span>
                            </h4>
                        </div>
                    </div>
                </div>


                  <!-- <div *ngIf="!showPieChart"
                      class="col-md-12 d-flex flex-column align-items-center justify-content-center text-center"
                      style="height: 360px">
                      <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium"
                          color="rgba(0, 0, 0, 0.1)" type="ball-scale-multiple"
                          [fullScreen]="false"></ngx-spinner>
                      <span class="mt-4">Loading</span>
                  </div> -->

                  <div class="row" *ngIf="showCombined">
                      <div class="col-xl-12">
                          <div class="carder">
                              <div class="card-body">
                                  <div class="row">
                                      <div class="col-md-6">
                                          <h4 class="card-title">Live Gantt Chart</h4>
                                      </div>
                                      <div class="col-md-6 text-md-right">
                                          <span
                                              class="badge bg-warning text-white mr-1">Idle</span>
                                          <span
                                              class="badge bg-light text-dark mr-1">Dryrun</span>
                                          <span
                                              class="badge bg-success text-white mr-1">Running</span>
                                          <span class="badge" *ngIf="!intervalFlag"
                                              (click)="LiveChart(params)">
                                              <i
                                                  class="ri-refresh-line align-middle mr-2"></i>Refresh
                                          </span>
                                      </div>
                                  </div>
                                  <app-combinechart *ngIf="showChart"
                                      [gaugeArray]="finalcombinedData"></app-combinechart>
                                  <div *ngIf="!showChart" class="text-center">
                                      <img src="assets/images/noData.jpg" width="100%" />
                                      <p>
                                          Please wait, we are fetching data / no data
                                          available.
                                      </p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="row">
                      <div class="col-md-12">
                          <div class="carder">
                              <div class="card-body">
                                  <div class="row">
                                      <div class="col-md-6">
                                          <!-- <h4 class="card-title">
                                              <select [(ngModel)]="selectedDateOption"
                                                  (change)="historyChart()">
                                                  <option value="Live">Today</option>
                                                  <option *ngFor="let data of previousDays"
                                                      [value]="data">
                                                      {{ data }}
                                                  </option>
                                              </select>
                                              Gantt Chart
                                          </h4> -->
                                      </div>
                                      <div class="col-md-6 text-md-right">
                                          <span
                                              class="badge bg-warning text-white mr-1">Idle</span>
                                          <span
                                              class="badge bg-success text-white mr-1">Running</span>
                                          <span
                                              class="badge bg-danger text-white mr-1">StandBy</span>
                                          <span
                                              class="badge bg-secondary text-white mr-1">Off</span>
                                      </div>
                                  </div>

                                  <div *ngIf="showload"
                                      class="d-flex flex-column align-items-center justify-content-center text-center"
                                      >
                                      <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="medium"
                                          color="rgba(0, 0, 0, 0.1)" type="ball-scale-multiple"
                                          [fullScreen]="false"></ngx-spinner>
                                      <span style="margin-top: 50px">Loading</span>
                                  </div>
                              </div>
                          </div>

                      </div>
                  </div>

              </div>

              <div *ngIf="historyDatas?.length == 0 && !showload" align="center">
                  <!-- <img src="assets/images/noData.jpg" width="50%" /> -->
                  <p class="mt-2 text-muted">
                      No data available / Fetching data...
                  </p>
              </div>

              <app-newganttchart *ngIf="showChart" [gaugeArray]="historyDatas" [title]="today"></app-newganttchart>
              <app-newganttchart *ngIf="showChart1" [gaugeArray]="currentDay" [title]="today2"></app-newganttchart>
              <app-newganttchart *ngIf="showChart1" [gaugeArray]="yesterDay" [title]="proviousDay"></app-newganttchart>
              <app-newganttchart *ngIf="showChart1" [gaugeArray]="previousyesterDay" [title]="proviousDay2"></app-newganttchart>
          </div>
      </div>
      <!-- <div class="col-md-12">
      </div> -->

  </div>
</div>

<ng-template #currenttemplate let-modal="close">

  <div class="modal-header">
      <h5 class="modal-title">{{ getTitle(trendData) }} Trend</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button>
  </div>

  <div class="modal-body text-center">
      <div class="justify-content-end text-md-right" *ngIf="trendData === 'current'">
          <label class="switch">
              <input type="checkbox" [(ngModel)]="isLineChart" (click)="toggleChart()" />
              <span class="slider round"></span>
          </label>
          <span class="ml-2">{{
              isLineChart ? "Line Chart" : "Scatter Chart"
              }}</span>
      </div>

      <div *ngIf="isLineChart && trendData === 'current'">
          <app-energychart [gaugeArray]="trendChart" [type]="trendData"
              *ngIf="trendChart['time']?.length != 0"></app-energychart>
          <div *ngIf="trendChart['time']?.length == 0" align="center">
              <img src="assets/images/noData.jpg" width="25%;" />
              <p class="mt-2 text-muted">No data available / Fetching data...</p>
          </div>
      </div>

      <div *ngIf="!isLineChart && trendData === 'current'">
          <app-scatter-chart [clusterArray]="cluster_data" *ngIf="clustr_Chart"></app-scatter-chart>
          <div *ngIf="!clustr_Chart" align="center">
              <img src="assets/images/noData.jpg" width="25%;" />
              <p class="mt-2 text-muted">No data available / Fetching data...</p>
          </div>
      </div>

      <div *ngIf="trendData !== 'current' && trendData !== 'partData'">
          <app-energychart [gaugeArray]="trendChart" [type]="trendData"
              *ngIf="trendChart['time']?.length != 0"></app-energychart>
          <div *ngIf="trendChart['time']?.length == 0" align="center">
              <img src="assets/images/noData.jpg" width="25%;" />
              <p class="mt-2 text-muted">No data available / Fetching data...</p>
          </div>
      </div>

      <div class="partData" *ngIf="trendData === 'partData'">
          <div class="col-md-12 text-center" *ngIf="showHourchart">
              <span class="fw-bold" [ngStyle]="{ color: intervalFlag ? 'green' : 'red' }">Hourly Part-Count</span>
              <app-partcountchart *ngIf="showHourchart" [gaugeArray]="hourlyData"></app-partcountchart>
          </div>
          <div *ngIf="!showHourchart" align="center">
              <img src="assets/images/noData.jpg" width="25%" />
              <p class="mt-2 text-muted">No data available / Fetching data...</p>
          </div>
      </div>

      <!-- <ng-template *ngIf="trendChart['time'][0]?.length != 0">
          <img src="assets/images/noData.jpg" width="50%" />
          <p class="mt-2 text-muted">No data available / Fetching data...</p>
      </ng-template> -->
  </div>

</ng-template>
<ng-template #piechart let-modal="close">
  <div class="modal-header">
      <h5 class="modal-title">Status Piechart</h5>
      <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
          <span aria-hidden="true">&times;</span>
      </button>
  </div>
  <div class="modal-body text-center d-flex justify-content-center">
      <div class="chart-container">
          <div echarts [options]="donughnutChart" class="demo-chart"></div>
      </div>
  </div>
</ng-template>
